/**
 * Created by akrio on 2018/4/29.
 */
import ConfirmComponent from "../../components/confirm/Index.vue";
import { mergeOptions } from "../../utils/plugin_helper";
import app from "../../main";

export function createVM(Vue) {
  const Confirm = Vue.extend(ConfirmComponent);
  const $vm = new Confirm({
    el: document.createElement("div"),
  });
  document.body.appendChild($vm.$el);
  return $vm;
}

let $vm;
/**
 * 确认取消弹出框
 */
export const ConfirmPlugin = {
  install(Vue) {
    if (!$vm) {
      $vm = createVM(Vue);
    }
    const confirm = {
      show(options = {}) {
        console.log("show(options = {})", options);
        $vm.input = undefined;
        $vm.title = "";
        const promise = new Promise((resolve) => {
          if (typeof options === "object") {
            mergeOptions($vm, options);
          } else if (typeof options === "string") {
            $vm.text = options;
            $vm.yesText = app.$t("common.yes");
          }
          if (!options.yesEvent) {
            $vm.yesEvent = async (val) => {
              resolve(val);
              return true;
            };
          }
        });
        if ($vm.cancelText === undefined) {
          $vm.cancelText = app.$t("common.cancel");
        }
        if ($vm.yesText === undefined) {
          $vm.yesText = app.$t("common.yes");
        }
        $vm.showModal = true;
        return promise;
      },
      hide() {
        $vm.showModal = false;
      },
    };
    Vue.mixin({
      created: function () {
        this.$confirm = confirm;
      },
    });
  },
};
/**
 * Alert 插件
 */
export const AlertPlugin = {
  install(Vue) {
    if (!$vm) {
      $vm = createVM(Vue);
    }
    console.log($vm);
    const alert = {
      show(options = {}) {
        $vm.cancelText = "";
        $vm.title = "";
        $vm.text = "";
        $vm.input = undefined;
        console.log($vm);
        const promise = new Promise((resolve) => {
          if (typeof options === "object") {
            mergeOptions($vm, options);
          } else if (typeof options === "string") {
            $vm.text = options;
          }
          $vm.yesEvent = async () => {
            resolve();
            return true;
          };
        });
        if ($vm.yesText === undefined) {
          $vm.yesText = app.$t("common.yes");
        }
        $vm.showModal = true;
        return promise;
      },
      hide() {
        $vm.showModal = false;
      },
    };
    Vue.mixin({
      created: function () {
        this.$alert = alert;
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/plugins/confirm/index.js